// Cross-Tab Auth-Sync via BroadcastChannel: meldet einem bereits offenen Tab
// sofort einen Login/Logout aus einem anderen Tab, sodass dieser seinen
// ['auth','me']-Cache invalidieren kann (z.B. Logout propagiert instant, statt
// erst beim nächsten 60s-Poll). Das Session-Cookie bleibt Single-Source-of-Truth.

const CHANNEL = 'embertime-auth'

export type AuthEvent = 'login' | 'logout'

/** Posten eines Auth-Events an alle anderen offenen Tabs derselben Origin. */
export function broadcastAuthChange(type: AuthEvent): void {
  if (typeof BroadcastChannel === 'undefined') return
  try {
    const ch = new BroadcastChannel(CHANNEL)
    ch.postMessage({ type })
    ch.close()
  } catch {
    // BroadcastChannel nicht verfügbar / blockiert -> still ignorieren.
  }
}

/** Abonniert Auth-Events aus anderen Tabs. Gibt eine unsubscribe-Funktion zurück. */
export function onAuthChange(handler: (type: AuthEvent) => void): () => void {
  if (typeof BroadcastChannel === 'undefined') return () => {}
  let ch: BroadcastChannel
  try {
    ch = new BroadcastChannel(CHANNEL)
  } catch {
    return () => {}
  }
  const listener = (e: MessageEvent) => {
    const type = (e.data as { type?: AuthEvent })?.type
    if (type === 'login' || type === 'logout') handler(type)
  }
  ch.addEventListener('message', listener)
  return () => {
    ch.removeEventListener('message', listener)
    ch.close()
  }
}
